import React, { useState, useEffect, useCallback, useRef } from "react";
import { API_BASE_URL } from "../../../config";

const POLL_MS = 10000;

const StockCard = ({ startDate, endDate, sellerId, sellerIds, onLogout, onSendToDisplay }) => {
    const [stockData, setStockData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [showAll, setShowAll] = useState(true);
    const pollRef = useRef(null);
    const isFirstRef = useRef(true);

    const getToken = useCallback(() => {
        const user = localStorage.getItem("user");
        if (!user) { onLogout?.(); return null; }
        return JSON.parse(user)?.token;
    }, [onLogout]);

    const fetchStock = useCallback(async (hard = false) => {
        const token = getToken();
        if (!token) return;
        if (hard || isFirstRef.current) setLoading(true);
        try {
            const payload = { start_date: startDate, end_date: endDate };
            if (sellerIds?.length) payload.seller_ids = sellerIds;
            else if (sellerId) payload.seller_id = sellerId;

            const res = await fetch(`${API_BASE_URL}/saledata/api/data/showdata/user`, {
                method: "POST",
                headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
                body: JSON.stringify(payload),
            });
            if (!res.ok) throw new Error(res.statusText);

            const rawJson = await res.json();
            const raw = Array.isArray(rawJson) ? rawJson : (Array.isArray(rawJson?.data) ? rawJson.data : []);

            // Aggregate product quantities across all sales
            const stockMap = new Map();
            raw.forEach(entry => {
                (entry.Normalize_Sale || []).forEach(item => {
                    const name = item.productName || item.iceCode || "-";
                    const qty = Number(item.quantity ?? 0) || 0;
                    stockMap.set(name, (stockMap.get(name) || 0) + qty);
                });
            });
            const sorted = Array.from(stockMap.entries())
                .map(([itemName, quantity]) => ({ itemName, quantity }))
                .sort((a, b) => b.quantity - a.quantity);
            setStockData(sorted);
            setError("");
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
            isFirstRef.current = false;
        }
    }, [getToken, startDate, endDate, sellerId, sellerIds, onLogout]);

    useEffect(() => {
        fetchStock(true);
        pollRef.current = setInterval(() => fetchStock(false), POLL_MS);
        return () => clearInterval(pollRef.current);
    }, [fetchStock]);

    const visible = showAll ? stockData : stockData.slice(0, 3);
    const total = stockData.reduce((s, i) => s + i.quantity, 0);

    return (
        <div className="btc-table-container">
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "6px", minHeight: "30px" }}>
                <strong style={{ fontSize: "13px" }}>รายการน้ำแข็ง</strong>
                <div style={{ display: "flex", gap: "6px" }}>
                    {onSendToDisplay && (
                        <button className="btc-btn btn-sm" onClick={() => onSendToDisplay("stock", stockData)}
                            style={{ padding: "4px 8px", fontSize: "12px", background: "#1976d2", color: "#fff", border: "none", borderRadius: "4px", cursor: "pointer" }}>
                            📺 ส่งไปแสดงผล
                        </button>
                    )}
                    {stockData.length > 3 && (
                        <button className="btc-btn btn-sm" onClick={() => setShowAll(v => !v)}
                            style={{ padding: "4px 8px", fontSize: "12px" }}>
                            {showAll ? "ย่อ" : "ดูทั้งหมด"}
                        </button>
                    )}
                </div>
            </div>
            {loading ? <p>Loading...</p> : error ? <p className="btc-error">{error}</p> : (
                <table className="btc-table">
                    <thead><tr><th>รายการ</th><th>จำนวน</th></tr></thead>
                    <tbody>
                        {visible.map((item, i) => (
                            <tr key={i}><td>{item.itemName}</td><td>{item.quantity}</td></tr>
                        ))}
                        <tr><td><strong>รวม</strong></td><td><strong>{total}</strong></td></tr>
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default StockCard;
